export default __webpack_public_path__ + "static/media/item_manipulative_overlay.7fd09c7d.png";